import React from 'react';

const PageNotFound = () => {
    return (
        <div className=''>
            <h1 className='text-4xl md:text-6xl font-bold text-slate-800 p-10 h-screen flex justify-center items-center'>Page Not Found 😬</h1>
        </div>
    )
}

export { PageNotFound }